import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface InitialSate {
  clientPopup: {
    id: number
    name: string
  }
}

const initialState: InitialSate = {
  clientPopup: {
    id: 0,
    name: '',
  },
}

const clientsSlice = createSlice({
  name: 'clients',
  initialState,
  reducers: {
    setClientPopup(state, action: PayloadAction<any>) {
      state.clientPopup = action.payload
    },
  },
})

export const clientsActions = clientsSlice.actions
export const clientsReducer = clientsSlice.reducer
